import { HRMS_LMS_API_URL } from '../../../Constants/baseConstant';
import { getDomain, getEmployeeId, getUserData } from '../../Base/helper/baseFunctions';
import axiosInstance from '../../../../axiosInstance';
import { toast } from 'react-toastify';
import NProgress from 'nprogress';

export const addFaceDataHelper = async (params) => {
    var data = getUserData();
    return await axiosInstance(`/lms/addFaceData`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: data.domain,
            user_id:data.employee_id,
            emp_id: params?.employee_id,
            record_time: params?.record_time,
            live_location: "",
            location_name: params?.location_name || "",
            mode: "Web"
        }
    })
        .then((res) => {
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            toast.error("Something went wrong");
            console.error(err?.response?.data?.error?.[0]?.message)
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const getFaceDataHelper = async (params) => {
    var data = getUserData();
    return await axiosInstance(`/lms/getFaceData`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: params?.domain_name || data?.domain,
            from_date: params?.from_date,
            to_date: params?.to_date,
            emp_id: params?.emp_id,
            reporting_manager_emp_id: params?.reporting_manager_emp_id
        }
    })
        .then((res) => {
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const addDistanceLogHelper = async (params) => {
    return await axiosInstance(`/lms/log-distance`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            emp_id: params?.emp_id,
            name: params?.name,
            distance: params?.distance,
            timestamp: new Date().toISOString(),
            userDescriptor: params?.userDescriptor || "",
            liveDescriptor: params?.liveDescriptor || ""
        }
    })
        .then((res) => {
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const getEmployeeLastAttendanceDataHelper = async (params) => {
    NProgress.start();
    return await axiosInstance(`/lms/getEmpLastAttendanceStatus`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: getDomain(),
            employee_id: params.employee_id,
        }
    })
        .then((res) => {
            NProgress.done();
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            NProgress.done();
            toast.dismiss();
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const addRecognizeFaceDataHelper = async (params) => {
  return await axiosInstance(`/lms/recognizeAddFaceData`, {
    method: "POST",
    baseURL: HRMS_LMS_API_URL,
    data: {
      domain_name: getDomain(),
      user_id: getEmployeeId(),
      record_time: params?.record_time,
      mode: "Web",
      img_b64string: params?.img_b64string,
      is_active: params?.is_active,
      face_location_restriction : params?.face_location_restriction,
      fetchEmployee_userid: params?.fetchEmployee_userid
    },
  })
    .then((res) => {
      return { message: "Success", hasError: false, data: res?.data };
    })
    .catch((err) => {
      return { message: "Error", hasError: true, data: err?.response?.data };
    });
};

// addRecognizeFaceDataTestHelper , used to test the changes, access will be enabled based on workspace level control
export const addRecognizeFaceDataTestHelper = async (params) => {
  return await axiosInstance(`/lms/recognizeAddFaceDataTest`, {
    method: "POST",
    baseURL: HRMS_LMS_API_URL,
    data: {
      domain_name: getDomain(),
      user_id: getEmployeeId(),
      record_time: params?.record_time,
      mode: "Web",
      img_b64string: params?.img_b64string,
      is_active: params?.is_active,
      face_location_restriction : params?.face_location_restriction,
      fetchEmployee_userid: params?.fetchEmployee_userid
    },
  })
    .then((res) => {
      return { message: "Success", hasError: false, data: res?.data };
    })
    .catch((err) => {
      return { message: "Error", hasError: true, data: err?.response?.data };
    });
};

// generateEmbeddingsController
export const generateEmbeddingsControllerHelper = async (params) => {
  return await axiosInstance(`/lms/generateEmbeddingsController`, {
    method: "POST",
    baseURL: HRMS_LMS_API_URL,
    data: {
      img_b64string: params?.img_b64string,
    },
  })
    .then((res) => {
      return { message: "Success", hasError: false, data: res?.data };
    })
    .catch((err) => {
      return { message: "Error", hasError: true, data: err?.response?.data };
    });
};

export const getWhatsappTimesheetHelper = async (params) => {
    return await axiosInstance(`/lms/getWhatsappTimesheet`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: params?.domain_name || getDomain(),
            from_date: params?.from_date,
            to_date: params?.to_date,
            emp_id: params?.emp_id || null,
            reporting_manager_emp_id: params?.reporting_manager_emp_id || null
        }
    })
        .then((res) => {
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}